// Иконата до „ЕИК" — едно поведение на трите места (издаване на фактура,
// редакция на получател, „Конфигурация → Фирми"): с валиден ЕИК тегли фирмата
// (`GET /customers/lookup`) и подава ВСИЧКИ ѝ полета (`lib/eikLookupFields.ts`)
// — каквото търсенето не върне, е празно, не остава от предишната фирма.
// `message` идва отвън: в Маркиране е `useOrderingMessage()` (настройката може
// да спира success toast-овете), другаде — `App.useApp().message`.

import type { MessageInstance } from "antd/es/message/interface";
import { useTranslation } from "react-i18next";
import { isValidEIK } from "../lib/companyValidators";
import { eikLookupFieldsOf, type EikLookupFields } from "../lib/eikLookupFields";
import { getApiErrorMessage } from "../utils/translations";
import { useEikLookup } from "./useCustomers";

export const useEikLookupFill = (
  message: Pick<MessageInstance, "success" | "warning" | "error">,
  onLookedUp: (fields: EikLookupFields) => void,
) => {
  const { t } = useTranslation();
  const eikLookup = useEikLookup();

  const lookup = async (eik: string) => {
    const trimmedEik = eik.trim();
    if (!isValidEIK(trimmedEik)) {
      message.warning(t("invoiceCreate.lookupInvalidEik"));
      return;
    }
    try {
      onLookedUp(eikLookupFieldsOf(await eikLookup.mutateAsync(trimmedEik)));
      message.success(t("invoiceCreate.lookupSuccess"));
    } catch (error: unknown) {
      message.error(getApiErrorMessage(error, t("invoiceCreate.lookupFailed")));
    }
  };

  return { lookup, isPending: eikLookup.isPending };
};
